var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.users),function(user){return _c('v-card',{key:user._id,staticClass:"mb-3",attrs:{"elevation":"3","to":{ name: 'list', params: { userID: user._id } }}},[_c('v-card-title',[_vm._v(_vm._s(user.username))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }